import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import 'intersection-observer' // for virtual scroller
import 'vue-property-decorator'
import 'moment-timezone'
import VueRaven from 'vue-raven'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
import Vuelidate from 'vuelidate'
import Snotify from 'vue-snotify'
import VueProgressBar from 'vue-progressbar'
import PortalVue from 'portal-vue'
import TreeView from 'vue-json-tree-view'
import VueObserveVisibility from 'vue-observe-visibility'
import VueVirtualScroller from 'vue-virtual-scroller'
import flatPickr from 'vue-flatpickr-component'
import {Env} from '../../env'

Vue.use(VueCompositionAPI)
Vue.use(VTooltip, {defaultBoundariesElement: 'window'})
Vue.use(VModal, {dynamic: true})
Vue.use(Vuelidate)
Vue.use(flatPickr)
Vue.use(PortalVue)
Vue.use(TreeView)
Vue.use(Snotify)
Vue.use(VueProgressBar, {color: '#8b3694', failedColor: '#dc3545', thickness: '2px'})
Vue.use(VueVirtualScroller)
Vue.use(VueObserveVisibility)

// TODO: remove vue-raven, use original sentry package
if (process.env.NODE_ENV === 'production') {
    Vue.use(VueRaven, {dsn: Env.ravenDsn, disableAutoReport: true})
} else {
    Vue.prototype.$raven = {
        // eslint-disable-next-line no-console
        captureException: console.log
    }
}
